<template>
  <help-info-wrapper
    :info.sync="helpData"
    :service-name="serviceName"
    class="warp"
  >
    <template>
      <v-card flat>
        <v-card-title class="justify-end pa-0">
          <div class="rowinfo">
            <v-btn
              class="rounded-lg"
              color="green"
              outlined
              @click="
                showCreate = true;
                discountEdite = null;
              "
            >
              <v-icon left>mdi-plus</v-icon>
              {{ $t("manageDiscount.createNewDiscount") }}
            </v-btn>
            <help-info
              :element-name="`${serviceName}-${componentName}-showCreate-discountEdite`"
              :service-name="serviceName"
              :help-data="helpData"
              class="buttoninfo"
              :label="$t('manageDiscount.createNewDiscount')"
            />
          </div>
        </v-card-title>

        <vue-table
          show-select
          :data="disCodes"
          :loading.sync="loading"
          :headers="headers"
          v-model="selection"
          @change="onPagination"
        >
          <template v-slot:index="{ item }">
            {{
              item.index + 1 + (disCodes.current_page - 1) * disCodes.per_page
            }}
          </template>
          <template v-slot:code="{ item }">
            <span
              :title="$t('manageDiscount.copy')"
              class="discountTitle"
              @click="copyTitle(item.discount_code[0].code)"
            >
              {{
                item.discount_code.length > 0 ? item.discount_code[0].code : "-"
              }}
            </span>
          </template>
          <template v-slot:id="{ item }">
            {{ item.discount_code.length > 0 ? item.discount_code[0].id : "-" }}
          </template>
          <template v-slot:using="{ item }">
            {{
              item.discount_code.length > 0
                ? item.discount_code[0].discount_limit
                : "-"
            }}
          </template>
          <template v-slot:used="{ item }">
            {{
              item.discount_code.length > 0
                ? item.discount_code[0].discount_limit -
                  item.discount_code[0].discount_limit
                : "-"
            }}
          </template>
          <template v-slot:action="{ item }">
            <ManageButton :data="item" :meta="metaButtons" />
          </template>
        </vue-table>

        <discount-editor
          :edit.sync="discountEdite"
          :show.sync="showCreate"
          @fetch="getDiscounts()"
        />
        <DiscountDelete
          @delete="deleteHandler()"
          :loading.sync="loading"
          :showDelete.sync="showDelete"
        />
      </v-card>
    </template>
  </help-info-wrapper>
</template>

<script>
import DiscountEditor from "@/view/pages/qrland/components/qrManage/manageShop/discountEditor.vue";
import { mapState } from "vuex/dist/vuex.common.js";
import DiscountDelete from "./discountDelete.vue";
import ManageButton from "@/view/pages/button.vue";

export default {
  name: "manageDiscount",

  components: { DiscountEditor, DiscountDelete, ManageButton },

  mounted() {
    this.getDiscounts();
  },

  data() {
    return {
      helpData: [],
      serviceName: "Qrland",
      componentName: "manageDiscount",
      disCodes: {},
      headers: [
        {
          value: "index",
          text: this.$t("manageDiscount.row"),
          sortable: false,
          align: "center",
        },
        {
          value: "id",
          text: this.$t("manageDiscount.id"),
          sortable: false,
          align: "center",
        },
        {
          value: "code",
          text: this.$t("manageDiscount.discountCode"),
          sortable: false,
          align: "center",
        },
        {
          value: "using",
          text: this.$t("manageDiscount.usageLimit"),
          sortable: false,
          align: "center",
        },
        {
          value: "used",
          text: this.$t("manageDiscount.used"),
          sortable: false,
          align: "center",
        },
        {
          value: "action",
          text: this.$t("manageDiscount.manage"),
          sortable: false,
          align: "center",
        },
      ],
      showDelete: false,
      showCreate: false,
      index: 0,
      selection: [],
      tableProps: {
        length: 10,
        page: 1,
      },
      discountId: 0,
      discountEdite: null,
      loading: false,
      metaButtons: {
        buttons: [
          {
            name: "getDiscounts",
            label: this.$t("manageDiscount.edit"),
            icon: "edit",
            class: "btn-outline-primary",
            action: this.action,
          },
          {
            name: "deleteHandler",
            label: this.$t("manageDiscount.delete"),
            icon: "trash",
            class: "btn-outline-danger",
            action: this.action,
          },
          {
            name: "sendSms",
            label: this.$t("manageDiscount.sendSms"),
            icon: "sms",
            class: "btn-outline-green",
            action: this.action,
          },
        ],
      },
    };
  },

  computed: {
    ...mapState("localstorage", ["createQrID"]),
  },

  methods: {
    getDiscounts(props = { length: 10, page: 1 }) {
      this.loading = true;
      this.$api
        .get("/v1/testQr/discount-code", {
          params: {
            qr_id: this.createQrID,
            ...props,
          },
        })
        .then(({ data }) => {
          let array = data.data.data.filter(
            (item) => item.discount_code.length > 0,
          );
          this.disCodes = data.data;
          this.disCodes.data = array;
        })
        .finally(() => (this.loading = false));
    },
    onPagination(e) {
      let props = {
        ...this.tableProps,
        ...e,
      };
      this.getDiscounts(props);
    },
    deleteHandler(e) {
      this.loading = true;
      this.$api
        .delete("/v1/testQr/discount-code/delete", {
          params: {
            id: this.discountId,
          },
        })
        .then(({ data }) => {
          this.getDiscounts();
          this.$toast.success(this.$t("manageDiscount.deleteSuccess"));
        })
        .catch((error) =>
          this.$toast.error(this.$t("manageDiscount.deleteError")),
        )
        .finally(() => (this.loading = false));
    },
    copyTitle(e) {
      navigator.clipboard
        .writeText(e)
        .then(() => this.$toast.success(this.$t("manageDiscount.copySuccess")))
        .catch(() => this.$toast.error(this.$t("manageDiscount.copyError")));
    },
    sendSms({ advanced_setting_id }) {
      this.loading = true;
      this.$api
        .get("/v1/testQr/Send-Message", {
          params: {
            advanced_setting_id,
            qr_id: this.createQrID,
          },
        })
        .then(({ data }) =>
          this.$toast.success(this.$t("manageDiscount.smsSuccess")),
        )
        .catch((error) => this.$toast.error(this.$t("manageDiscount.smsError")))
        .finally(() => (this.loading = false));
    },
    action(data, type) {
      switch (type) {
        case "getDiscounts":
          {
            this.showCreate = true;
            this.discountEdite = data;
          }
          break;
        case "deleteHandler":
          {
            this.showDelete = true;
            this.discountId =
              data.discount_code.length > 0 ? data.discount_code[0].id : null;
          }
          break;
        case "sendSms": {
          this.sendSms({
            advanced_setting_id: data.discount_code[0].advanced_setting_id,
          });
        }
      }
    },
  },
};
</script>

<style scoped>
.discountTitle {
  cursor: pointer;
}
</style>
